import Swiper from 'swiper';
import {Navigation, FreeMode} from 'swiper/modules';
import {gsap} from '../../../vendors/gsap';
import createFilterNavigation from '../../common/createFilterNavigation/index';
import getDOMfromString from '../../../helpers/getDOMfromString';

/**
 * This method creates and returns text carousel
 *
 * @param {Object} config - options to customize carousel
 * @returns {Object} - slide up and down methods
 */
const createTagCarousel = config => {
    const {storyData, labels} = config;
    const data = Array.isArray(storyData) ? storyData : [];
    const slideCount = data.length;
    let activeIndex = 0;
    let activeTags = [];
    const tagsContainer = document.querySelector('.story-tags .swiper-wrapper');
    let tagSwiper = null;

    /**
     * Generates and returns tags
     *
     * @returns {Array} - array of tags
     */
    const getTags = () => {
        return data[activeIndex].allTags ?? [];
    };

    /**
     * Sets and render tags
     */
    const setTags = () => {
        activeTags = getTags();

        tagsContainer.replaceChildren();

        activeTags.forEach(tag => {
            if (tag.length > 0) {
                const tagEl = getDOMfromString(`<div class="tag swiper-slide" data-tag="${tag}">${tag}</div>`);
                tagsContainer.append(tagEl);
            }
        });

        if (tagSwiper && tagSwiper.updateSlides) {
            tagSwiper.updateSlides();
            tagSwiper.slideTo(0);
        }
    };

    /**
     * This function animates adds/removes tags
     *
     * @param {string} type - next/prev
     * @param {number} slideIndex - slide index
     */
    function updateTags(type = 'next', slideIndex = undefined) {
        if (slideIndex === activeIndex) return;

        gsap.utils.toArray('.toRemove').forEach(el => {
            el.remove();
        });

        if (slideIndex !== undefined) {
            activeIndex = slideIndex;
        } else if (type === 'prev') {
            activeIndex = (activeIndex - 1 + slideCount) % slideCount;
        } else {
            activeIndex = (activeIndex + 1) % slideCount;
        }

        setTags();
    }

    /**
     * Adds filter navigation buttons to filter carousel
     */
    const addFilterNavigation = () => {
        const container = document.querySelector('.story-tags-wrapper');
        const navEl = createFilterNavigation({
            navClasses: 'story-tags-navigation',
            prevBtnClasses: 'tag-btn-prev',
            nextBtnClasses: 'tag-btn-next',
            forceShow: true,
            labels: labels
        });
        container.append(navEl);
    };

    /**
     * generates the initial tags
     */
    function generateTags() {
        setTags();

        addFilterNavigation();

        tagSwiper = new Swiper('.story-tags-carousel', {
            modules: [Navigation, FreeMode],
            loop: false,
            spaceBetween: 8,
            slidesPerView: 'auto',
            allowTouchMove: true,
            speed: 400,
            watchOverflow: true,
            observer: true,

            // navigation
            navigation: {
                nextEl: '.tag-btn-next',
                prevEl: '.tag-btn-prev',
                lockClass: false
            },
            freeMode: {
                enabled: true
            }
        });
    }

    generateTags();

    return {
        updateTags
    };
};

export default createTagCarousel;
